module.exports = vendor_dll;